/**
 * Breakpoint e input: classi su <html> per CSS condizionale e helper per JS.
 */
const MQ_NARROW = '(max-width: 900px)';
const MQ_COARSE = '(pointer: coarse)';
const MQ_NO_HOVER = '(hover: none)';

export function isMobileViewport() {
  return typeof window !== 'undefined' && window.matchMedia(MQ_NARROW).matches;
}

export function isCoarsePointer() {
  return typeof window !== 'undefined' && window.matchMedia(MQ_COARSE).matches;
}

export function prefersNoHover() {
  return typeof window !== 'undefined' && window.matchMedia(MQ_NO_HOVER).matches;
}

/** Aggiorna layout-narrow, layout-touch, layout-no-hover su document.documentElement. */
export function initLayoutHints() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const apply = () => {
    root.classList.toggle('layout-narrow', window.matchMedia(MQ_NARROW).matches);
    root.classList.toggle('layout-touch', window.matchMedia(MQ_COARSE).matches);
    root.classList.toggle('layout-no-hover', window.matchMedia(MQ_NO_HOVER).matches);
  };
  apply();
  try {
    window.matchMedia(MQ_NARROW).addEventListener('change', apply);
    window.matchMedia(MQ_COARSE).addEventListener('change', apply);
    window.matchMedia(MQ_NO_HOVER).addEventListener('change', apply);
  } catch (_) {
    window.matchMedia(MQ_NARROW).addListener(apply);
    window.matchMedia(MQ_COARSE).addListener(apply);
    window.matchMedia(MQ_NO_HOVER).addListener(apply);
  }
}
